import { ViewModel } from '../../view-model';
import { CONFIG } from '../../../core/config';

export class RiskMatrixBand implements ViewModel {
  readonly friendlyTypeNameSingular = 'Risk Matrix Band';
  readonly apiRoute: string = CONFIG.apiRoutes.riskMatrixBands;

  riskMatrixBandId: string;
  name: string;
  color = '#FFFFFF';
  riskMatrixId: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.riskMatrixBandId = data.riskMatrixBandId;
    this.name = data.name;
    this.color = data.color;
    this.riskMatrixId = data.riskMatrixId;
  }
}
